import { useEffect, useState, useRef } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import api from "../api/api";
import "../styles/history.css";
import Button from "../components/Button";
 
export default function History() {
  const [history, setHistory] = useState({});
  const [dateRange, setDateRange] = useState([null, null]);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState("");
 
  const inputRef = useRef(null);
  const [startDate, endDate] = dateRange;
 
  const OPTIONS = [
    { value: "sale", label: "Sale" },
    { value: "purchase", label: "Purchase" },
    { value: "harvest", label: "Harvest" },
  ];
 
  const fetchHistory = async (params = {}) => {
    try {
      setLoading(true);
      const res = await api.get("/history", { params });
      setHistory(res?.data?.history ?? {});
    } catch (error) {
      console.error("History fetch error", error);
      setHistory({});
    } finally {
      setLoading(false);
    }
  };
 
  useEffect(() => {
    fetchHistory();
  }, []);
 
  /* ================= FILTER HANDLERS ================= */
  const applyFilters = () => {
    fetchHistory({
      fromdate: startDate ? startDate.toISOString() : undefined,
      todate: endDate ? endDate.toISOString() : undefined,
      historytype:
        selectedTypes.length > 0
          ? selectedTypes.map((o) => o.value).join(",")
          : undefined,
      createdby: selectedUser || undefined,
    });
    setOpen(false);
  };
 
  const clearFilters = () => {
    setDateRange([null, null]);
    setSelectedTypes([]);
    setSelectedUser("");
    fetchHistory();
    setOpen(false);
  };
 
  const toggleCalendar = () => setOpen(!open);
 
  return (
    <div
      className="history-page overflow-y-auto overflow-x-hidden mx-4"
      style={{ maxHeight: "calc(100vh - 100px)" }}
    >
      <div
        className="position-sticky top-0 pb-3"
        style={{ backgroundColor: "#f1f5f9" }}
      >
        <div className="history-filters">
          <div className="row align-items-center mb-4">
            {/* Custom Date Range Input */}
            <div className="col-sm-6 col-md-3 position-relative mt-0">
              <input
                ref={inputRef}
                readOnly
                value={
                  startDate && endDate
                    ? `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`
                    : ""
                }
                onClick={toggleCalendar}
                placeholder="Select Date Range From To"
                className="form-control"
              />
              {open && (
                <div className="position-absolute bg-white shadow p-3 rounded mt-1 z-3">
                  <DatePicker
                    inline
                    selectsRange
                    monthsShown={2}
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => setDateRange(update)}
                    maxDate={new Date()}
                  />
 
                  <div className="d-flex justify-content-end">
                    <Button
                      className="btn btn-primary btn-sm mt-3"
                      onClick={() => setOpen(false)}
                      text="Close"
                    />
                  </div>
                </div>
              )}
            </div>
 
            {/* Multi-Select Dropdown */}
            <div className="col-md-4 col-lg-3 mt-3 mt-md-0">
              <Select
                isMulti
                options={OPTIONS}
                value={selectedTypes}
                onChange={(opts) => setSelectedTypes(opts || [])}
                placeholder="Select Entry Types"
                className="history-select"
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
              />
            </div>
            <div className="col-sm-6 col-md-4 col-lg-3 d-flex mt-3 mt-sm-0 align-items-center gap-2">
              <Button
                onClick={applyFilters}
                text="Apply Filter"
                btncls="me-2 mt-0 w-100 w-sm-auto"
              />
              <Button
                onClick={clearFilters}
                text="Clear Filter"
                variant="secondary"
                btncls="mt-0 bg-secondary w-100"
              />
            </div>
          </div>
        </div>
      </div>
 
      {/* ===== HISTORY LIST ===== */}
      {loading ? (
        <p className="loading">Loading...</p>
      ) : Object.keys(history).length > 0 ? (
        Object.entries(history).map(([date, items]) => (
          <div key={date} className="date-group">
            <h4 className="date-heading">{date}</h4>
 
            {Array.isArray(items) && items.length > 0 ? (
              items.map((item, index) => (
                <div key={index} className="history-item">
                  <p className="product-name">{item.product_name}</p>
                  <p className={`quantity text-center ${item.entry_type}`}>
                    {item.quantity} {item.unit_name}
                  </p>
                  <p className="amount text-end">
                    {item.total_amount !== null &&
                    item.total_amount !== undefined
                      ? `₹ ${item.total_amount}`
                      : "--"}
                  </p>
                </div>
              ))
            ) : (
              <p className="no-data">No records</p>
            )}
          </div>
        ))
      ) : (
        <p className="no-data">No history found</p>
      )}
    </div>
  );
}